import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import Scrollable from "../../Shared/Edit/Scrollable";
import ComponentToolbar from "./ComponentToolbar/ComponentToolbar";
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { useSelectedPage } from "../../../Hooks/Display/usePages";
import { useSelectedComponent } from "../../../Hooks/Display/useComponents";
import { usePropsStoreValue } from "../../../Hooks/PropStore/usePropsStore";
import { useComponentProperties } from "../../../Hooks/Display/useComponentProperties";
import { InsertImage } from "./Content/InsertImage/insertImageTool";

const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    ForeColor,
    BackColor,
    CleanFormatting,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    FormatBlock,
    Link,
    Unlink,
    ViewHtml,
    InsertTable,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    MergeCells,
    SplitCell,
} = EditorTools;

function Content() {

    const selectedPage = useSelectedPage();
    const selectedComponent = useSelectedComponent();
    const accessedFromDesigner = usePropsStoreValue("accessedFromDesigner");

    const [properties, setProperty] = useComponentProperties();

    function handleContent(e) {
        setProperty("value", e.htmlValue);
    };

    return (
        <div className={"h-100 d-flex flex-column line" + (!accessedFromDesigner && " runtimePopup")}>
            <ComponentToolbar />
            <Scrollable>
                <TabStrip className="flex-grow-1 h-100 edit1" selected={0}>
                    <TabStripTab>
                        <Scrollable>
                            <form className="p-2">
                                <Editor
                                    tools={[
                                        [
                                            Bold,
                                            Italic,
                                            Underline,
                                            Strikethrough,
                                        ],
                                        [
                                            AlignLeft,
                                            AlignCenter,
                                            AlignRight,
                                            AlignJustify,
                                        ],
                                        [
                                            OrderedList,
                                            UnorderedList,
                                            Subscript,
                                            Superscript,
                                            Indent,
                                            Outdent,
                                        ],
                                        ForeColor,
                                        BackColor,
                                        [CleanFormatting],
                                        FontSize,
                                        FontName,
                                        FormatBlock,
                                        [Undo, Redo],
                                        [
                                            InsertTable,
                                            AddRowBefore,
                                            AddRowAfter,
                                            AddColumnBefore,
                                            AddColumnAfter,
                                            DeleteRow,
                                            DeleteColumn,
                                            DeleteTable,
                                            MergeCells,
                                            SplitCell,
                                        ],
                                        [Link, Unlink, InsertImage, ViewHtml],
                                    ]}
                                    onExecute={(e) => {
                                        if (selectedComponent.hidden) {
                                            return !e.transaction.docChanged;
                                        }
                                    }}
                                    contentStyle={{
                                        height: 500,
                                        width: "100%",
                                    }}
                                    defaultContent={selectedComponent.value}
                                    value={properties.value}
                                    onChange={handleContent}
                                />
                            </form>
                        </Scrollable>
                    </TabStripTab>
                </TabStrip>
            </Scrollable>
        </div>
    )
}

export default Content;